import React from 'react';

const Page404 = () => {
  return (
    <div className='flex items-center justify-center h-full flex-col dark:text-white'>
      <h1>404</h1>
      <p>Sorry, the page you visited does not exist.</p>
    </div>
  );
};

export default Page404;
